module.exports = __webpack_public_path__ + "img/st-4.40aaf7c7.png";